import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import type { CreateCustomerInput } from "@adva/types";
import { EntityForm } from "@/components/v2/entity-form";
import { useCreateCustomer } from "@/hooks/use-api";
import { CUSTOMER_FIELDS } from "./customer-form-config";

export default function V2CustomerCreatePage() {
  const navigate = useNavigate();
  const createCustomer = useCreateCustomer();
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(values: CreateCustomerInput) {
    setError(null);
    try {
      const { customer } = await createCustomer.mutateAsync(values);
      toast.success("Customer created");
      // The customer detail route (GET /core/customers/:id) looks up by
      // contact_id, not contact_role_id (Codex review on PR #1014).
      navigate(`/customers/${customer.contact_id}`);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Could not create the customer — check the fields and try again.",
      );
    }
  }

  return (
    <EntityForm<CreateCustomerInput>
      title="Create customer"
      breadcrumbs={[
        { label: "Customers", href: "/customers" },
        { label: "New" },
      ]}
      defaultValues={{ lifecycle_status: "lead" }}
      fields={CUSTOMER_FIELDS}
      submitLabel="Create customer"
      onSubmit={onSubmit}
      cancelHref="/customers"
      error={error}
      isSubmitting={createCustomer.isPending}
    />
  );
}
